import { useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useIsMobile } from "@/hooks/use-mobile";
import { HelpCircle } from "lucide-react";

type Props = {
  text: string;
  children?: React.ReactNode;
  /** Show inline help icon instead of wrapping children */
  icon?: boolean;
};

export default function AdminTooltip({ text, children, icon }: Props) {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  const triggerEl = icon ? (
    <HelpCircle
      className="w-3 h-3 text-muted-foreground/60 hover:text-muted-foreground cursor-help inline-block ml-1"
      onClick={(e) => {
        if (isMobile) {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }
      }}
    />
  ) : (
    <span
      onClick={(e) => {
        if (isMobile) {
          e.preventDefault();
          e.stopPropagation();
          setOpen((v) => !v);
        }
      }}
    >
      {children}
    </span>
  );

  if (isMobile) {
    return (
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>{triggerEl}</PopoverTrigger>
        <PopoverContent side="top" className="max-w-[280px] p-3 font-mono text-[11px]">
          <p>{text}</p>
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{triggerEl}</TooltipTrigger>
        <TooltipContent side="top" className="max-w-[250px] font-mono text-[11px]">
          <p>{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
